// useDashboardData.ts
import { useEffect, useState } from "react";
import { DashboardData } from "../types/dashboard";
import api from "../../../../../features/auth/axiosConfig";

type Mode = "year" | "range";

interface UseDashboardDataProps {
  mode: Mode;
  year?: number;
  startDate?: string;
  endDate?: string;
  enabled?: boolean; // Add this
}

export const useDashboardData = ({ mode, year, startDate, endDate, enabled = true }: UseDashboardDataProps) => {
  const [dashboardData, setDashboardData] = useState<DashboardData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Don't fetch if not enabled
    if (!enabled) {
      return;
    }

    const fetchData = async () => {
      try {
        let params: any;
        if (mode === "year") {
          if (typeof year !== "number") return;
          params = { year };
        }
        if (mode === "range") {
          if (!startDate || !endDate) return;
          if (new Date(startDate) > new Date(endDate)) return;
          params = { start_date: startDate, end_date: endDate };
        }
        setLoading(true);
        setError(null);
        const res = await api.get("/app/pos/v2/dashboard", { params });
        setDashboardData(res.data);
      } catch (e) {
        console.error(e);
        setError("Failed to load dashboard data");
        setDashboardData(null);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [mode, year, startDate, endDate, enabled]);

  return { dashboardData, loading, error };
};